export interface PostModel {
  id?: string;
  title?: string;
  postedBy?: string;
  yearRange?: string;
  startDate?: string;
  endDate?: string;
  priceDoubleRoom?: string;
  priceQuadRoom?: string;
  priceTicket?: string;
  priceNotes?: string;
  contactName?: string;
  contactEmail?: string;
  text?: string;
  bannerImageUrl?: string;
  updatedAt?: string;
  hideDate?: boolean;
}

export function postModelFactory(json?: any): PostModel {
  json = json || {};

  return {
    id: (json["id"] || undefined) as String,
    title: json["title"] || "",
    postedBy: json["postedBy"] || "",
    yearRange: json["yearRange"] || "",
    startDate: (json["startDate"] || "").split("T")[0],
    endDate: (json["endDate"] || "").split("T")[0],
    priceDoubleRoom: json["priceDoubleRoom"] || "",
    priceQuadRoom: json["priceQuadRoom"] || "",
    priceTicket: json["priceTicket"] || "",
    priceNotes: json["priceNotes"] || "",
    contactName: json["contactName"] || "",
    contactEmail: json["contactEmail"] || "",
    text: json["text"] || "",
    bannerImageUrl: json["bannerImageUrl"] || "",
    updatedAt: (json["updatedAt"] || "").split("T")[0],
    hideDate: !!json["hideDate"],
  } as PostModel;
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/post.model.ts